import gql from 'graphql-tag';

import { FULL_COMMENT_FRAGMENT } from '../fragments/Comment/fullComment';
import { POST_DETAILS_FRAGMENT } from '../fragments/Post/postDetails';

export const GET_POSTS_SUBSCRIPTION = gql`
  subscription GetPostsSubscription(
    $plexIds: [String!]!
    $types: [PostType!]!
    $publishStatuses: [PublishStatus!]!
    $labelIds: [String!]!
    $before: DateTime
    $onOrAfter: DateTime
  ) {
    posts(
      filters: {
        plexIds: $plexIds
        types: $types
        publishStatuses: $publishStatuses
        labelIds: $labelIds
        before: $before
        onOrAfter: $onOrAfter
      }
    ) {
      ...postDetails
      comments {
        ...fullComment
      }
      plex {
        id
        summary {
          id
          postsCount
        }
      }
    }
  }

  ${POST_DETAILS_FRAGMENT}
  ${FULL_COMMENT_FRAGMENT}
`;
